import React from 'react';
import { CheckCircleIcon, LightningBoltIcon, TrendingUpIcon, SupportIcon } from '@heroicons/react/outline';

const features = [
  {
    title: 'Fast Transactions',
    description:
      'Experience lightning-fast transactions with minimal fees. Our platform ensures your assets are moved securely and without delays.',
    icon: LightningBoltIcon,
  },
  {
    title: 'Real-time Analytics',
    description:
      'Track your performance in real time with detailed charts and analytics to help you make better investment decisions.',
    icon: TrendingUpIcon,
  },
  {
    title: '24/7 Support',
    description:
      'Our support team is available 24/7 to assist with any questions or issues, ensuring you have the help you need whenever you need it.',
    icon: SupportIcon,
  },
  {
    title: 'Trusted Security',
    description:
      'Security is our top priority. Your assets are safe with multi-layered encryption and the highest industry standards.',
    icon: CheckCircleIcon,
  },
];

const FeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-500 p-6 text-center">
      <div className="flex justify-center mb-4">
        <Icon className="h-12 w-12 text-blue-500 animate-pulse" />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const Features = () => {
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-12 animate-fadeIn">
          Our Platform Features
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`opacity-0 animate-fadeInUp delay-${index * 200}`}
              style={{ animationDelay: `${index * 300}ms` }}
            >
              <FeatureCard
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
              />
            </div>
          ))}
        </div>
      </div>
		</div>
  );
};

export default Features;

